module.exports = __webpack_public_path__ + "img/trash-slash.6187e37e.svg";